export enum BonusRuleType {
  INTERACTION = "INTERACTION",
  TRANSACTION = "TRANSACTION",
}
